
export function customerService (data) {
    console.log(data)
    //判断环境
    let u = navigator.userAgent
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        if (window?.jxyy?.contactWxCustomerService) {
            window.jxyy.contactWxCustomerService(data.corpId, data.url)
        } else {
            window.location.href = data.url
        }
    } else if (isiOS) {
        if (window?.webkit?.messageHandlers?.contactWxCustomerService) {
            window.webkit.messageHandlers.contactWxCustomerService.postMessage("kf");
        } else {
            window.location.href = data.url
        }
    } else {
        window.location.href = data.url
    }
}